import {styled} from "@mui/material/styles";
import Box from "@mui/material/Box";
import Button from "@mui/material/Button";
import LoadingButton from "@mui/lab/LoadingButton";

interface ToggleDrawerButtonProps {
    drawerOpen?: boolean;
}

export const ToggleDrawerButton = styled(Button, { 
    label: "ToggleDrawerButton",
    shouldForwardProp: (prop) => prop !== 'drawerOpen'
})<ToggleDrawerButtonProps>(({theme, drawerOpen}) => ({
    "&:hover": {
        borderColor: "#E2E3EB",
        backgroundColor: theme.palette.background.default,
    },
    backgroundColor: theme.palette.background.default,
    borderColor: theme.palette.text.secondary,
    borderRadius: "19px",
    color: theme.palette.text.secondary, // drawer z-index is 1200
    fontSize: "0.875rem",
    fontWeight: "bold",
    height: "38px",
    lineHeight: "2.0",
    padding: "6px 24px",
    position: "absolute",
    textTransform: "none",
    top: "30px",
    left: drawerOpen ? `${window.innerWidth * 0.28 + 80}px` : '80px',
    transition: "all 225ms cubic-bezier(0.4, 0, 0.6, 1) 0ms",
    zIndex: 1201
}));

export const FormContainerBox = styled(Box)(({theme}) => ({
    margin: "58px 18px 0px 74px",
    overflow: "auto",
    paddingRight: "56px",
    scrollbarWidth: "thin"
}));

export const FormLoadingButton = styled(LoadingButton)(() => ({
    borderRadius: "19px",
    fontSize: "0.875rem",
    height: "38px",
    lineHeight: "2.0",
    margin: "0 8px",
    padding: "6px 24px",
    textTransform: "none"
}));

export const EditorContainerBox = styled(Box)(({theme}) => ({
    position: "absolute",
    left: 0,
    right: 0,
    top: 48,
    bottom: 0,
    overflow: 'hidden'
}));